import styled from '@emotion/styled';
import { css } from '@emotion/react';

export type BadgeVariant =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'neutral';

export type BadgeSize = 'sm' | 'md';

type StyledProps = {
  $variant: BadgeVariant;
  $size: BadgeSize;
  $color?: string;
  $backgroundColor?: string;
};

const palette: Record<BadgeVariant, { bg: string; color: string }> = {
  primary: { bg: '#E8E6FF', color: '#4A3FD6' },
  success: { bg: '#E6F7E6', color: '#2E7D32' },
  warning: { bg: '#FFF4D6', color: '#B8860B' },
  danger: { bg: '#FFE6E6', color: '#C62828' },
  info: { bg: '#E0F7FA', color: '#00838F' },
  neutral: { bg: '#F0F0F0', color: '#575757' },
};

const sizeStyles = {
  sm: css`
    padding: 2px 6px;
    font-size: 12px;
    border-radius: 6px;
  `,
  md: css`
    padding: 5px 8px;
    font-size: 14px;
    border-radius: 8px;
  `,
};

export const StyledBadge = styled('span', {
  shouldForwardProp: (prop) => !prop.toString().startsWith('$'),
})<StyledProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  font-family: 'Mangueira', sans-serif;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;

  background-color: ${({ $backgroundColor, $variant }) =>
    $backgroundColor || palette[$variant].bg};
  color: ${({ $color, $variant }) => $color || palette[$variant].color};

  ${({ $size }) => sizeStyles[$size]}
`;
